module.exports = __webpack_public_path__ + "img/two.4af72752.svg";